/* eslint-disable no-dupe-keys */
<template>
  <div class="RealNameReport">
    <div>
      <van-form @submit="onSubmit" @failed="onFailed" ref="FormRef">
        <van-cell-group class="form_filed">
          <div class="label">
            <span class="xinhao">*</span><span class="jianju">真实姓名</span>
          </div>
          <van-field placeholder="真实姓名不能为空，且只允许包括中文或英文" v-model="form.realName" maxlength="10" class="input_box" :rules="[
                       { required: true, message: '必填' },
                       {
                         validator: asValidator,
                         message: '真实姓名不能为空，且只允许包括中文或英文',
                        },
                      ]" />
        </van-cell-group>
        <!-- 性别 -->
        <van-cell-group class="form_filed">
          <div class="label"><span class="xinhao">*</span><span class="jianju">性别</span></div>
          <van-field v-model="form.gender" show-error='false' :rules="[{required:true,message:'必填'}]">
            <template #input>

              <span class="xingbieanniu" native-type="button" :class="form.gender === '0' && 'xingbieanniudianji'" @click="form.gender = '0'" >男</span>
              <span class="xingbieanniu" native-type="button" :class="form.gender === '1' && 'xingbieanniudianji'" @click="form.gender = '1'" >女</span>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group class="form_filed">
          <div class="label">
            <span class="xinhao">*</span><span class="jianju">电子邮箱</span>
          </div>
          <van-field placeholder="请输入正确的电子邮箱" v-model="form.email" maxlength="50" type="email" class="input_box" :rules="[
              { required: true, message: '必填',  },
              {
                pattern:
                  /@/,
                message: '电子邮箱格式错误',
              },
            ]" />
        </van-cell-group>
        <van-cell-group class="form_filed">
          <div class="label">
            <span class="xinhao">*</span><span class="jianju">手机号</span>
          </div>
          <van-field placeholder="请输入正确的手机号" maxlength="11" v-model="form.phone" class="input_box" :rules="[
              { required: true, message: '必填' },
              {
                pattern: /^\d{11}$/,
                message: '手机号码格式不正确。',
              },
            ]" />
        </van-cell-group>
        <!-- 所处地域 -->
        <van-cell-group class="form_filed">
          <div class="label"><span class="xinhao">*</span><span class="jianju">所处地域<span class="xinhao_jianju">（所在地 / 服务地）</span></span></div>
          <div class="van-cell van-field noBorder">
            <!-- :value="form.province_code.province ? province_list.find( (v) => v.id / 1 === form.province_code.province ).name: ''" -->
            <van-field style="margin-right: 2vw" readonly clickable name="picker" :value="province_val" placeholder="请选择" :rules="[  { required: true, message: '必填' },]" @click="pikerShow.province_code__province = true">
              <template #button>
                <span style="color: rgba(102, 102, 102, 1)">省</span>
              </template>
            </van-field>
            <!-- :value=" form.province_code.city ? city_list.find( (v) => v.id / 1 === form.province_code.city).name : '' " -->
            <van-field style="margin-right: 2vw" readonly clickable name="picker" :value="city_val" :rules="[  { required: true, message: '必填' },]" placeholder="请选择" @click="
                    form.province_code.province &&
                      (pikerShow.province_code__city = true)
                  ">
              <template #button>
                <span style="color: rgba(102, 102, 102, 1)">市</span>
              </template>
            </van-field>
            <van-field style="margin-right: 2vw" readonly clickable name="picker" :value="county_val" :rules="[  { required: true, message: '必填' },]" placeholder="请选择" @click="
                    form.province_code.city &&
                      (pikerShow.province_code__county = true)
                  ">
              <template #button>
                <span style="color: rgba(102, 102, 102, 1)">区/县</span>
              </template>
            </van-field>
            <van-popup v-model="pikerShow.province_code__province" position="bottom">
              <van-picker value-key="name" show-toolbar :columns="province_list.slice(1)" @confirm="
                      (value) =>
                        onConfirmCity(
                          value,
                          'province_code__province',
                          'province_code__city',
                          '1'
                        )
                    " @cancel="pikerShow.province_code__province = false" />
            </van-popup>
            <van-popup v-model="pikerShow.province_code__city" position="bottom">
              <van-picker value-key="name" show-toolbar :columns="city_list.slice(1)" @confirm="
                      (value) =>
                        onConfirmCity(value, 'province_code__city', 'province_code__county', '2')
                    " @cancel="pikerShow.province_code__city = false" />
            </van-popup>
            <van-popup v-model="pikerShow.province_code__county" position="bottom">
              <van-picker value-key="name" show-toolbar :columns="county_list.slice(1).filter(item => item.name !== '市本级')" @confirm="
                      (value) =>
                        onConfirmCity(value, 'province_code__county', '', '5')
                    " @cancel="pikerShow.province_code__county = false" />
            </van-popup>
          </div>
        </van-cell-group>
        <!-- 举报地域（被举报内容属地） -->
        <van-cell-group class="form_filed">
          <div class="label"><span class="xinhao">*</span><span>举报地域</span><span class="xinhao_jianju">（被举报内容属地）</span></div>
          <div class="van-cell van-field noBorder">
            <!-- :value="form.native_place.province1? areaList.province_list.find( (v) => v.id / 1 === form.native_place.province1).name : ''" -->
            <van-field style="margin-right: 2vw" readonly clickable :rules="[  { required: true, message: '必填' },]" :value="province1_val" name="picker" placeholder="请选择" @click="pikerShow.native_place__province1 = true">
              <template #button>
                <span style="color: rgba(102, 102, 102, 1)">省</span>
              </template>
            </van-field>
            <!-- :value=" form.native_place.city1? areaList.city_list.find( (v) => v.id / 1 === form.native_place.city1 ).name: ''" -->
            <van-field v-if="province1_val != '不清楚'" style="margin-right: 2vw" readonly clickable :value="city1_val" :rules="[  { required: true, message: '必填' },]" name="picker" placeholder="请选择" @click="
                        form.native_place.province1 &&
                          (pikerShow.native_place__city1 = true)
                      ">
              <template #button>
                <span style="color: rgba(102, 102, 102, 1)">市</span>
              </template>
            </van-field>
            <van-field v-if="province1_val != '不清楚' && city1_val != '不清楚'" style="margin-right: 2vw" readonly clickable :value="county1_val" :rules="[  { required: true, message: '必填' },]" name="picker" placeholder="请选择" @click="
                        form.native_place.city1 &&
                          (pikerShow.native_place__county1 = true)
                      ">
              <template #button>
                <span style="color: rgba(102, 102, 102, 1)">区/县</span>
              </template>
            </van-field>
            <van-popup v-model="pikerShow.native_place__province1" position="bottom">
              <van-picker value-key="name" show-toolbar :columns="areaList.province_list" @confirm="
                          (value) =>
                            onConfirmCity(
                              value,
                              'native_place__province1',
                              'native_place__city1',
                              '3'
                            )
                        " @cancel="pikerShow.native_place__province1 = false" />
            </van-popup>
            <van-popup v-model="pikerShow.native_place__city1" position="bottom">
              <van-picker value-key="name" show-toolbar :columns="areaList.city_list" @confirm="
                          (value) =>
                            onConfirmCity(value, 'native_place__city1', 'native_place__county1', '4')
                        " @cancel="pikerShow.native_place__city1 = false" />
            </van-popup>
            <van-popup v-model="pikerShow.native_place__county1" position="bottom">
              <van-picker value-key="name" show-toolbar :columns="areaList.county_list.filter(item => item.name !== '市本级')" @confirm="
                          (value) =>
                            onConfirmCity(value, 'native_place__county1', '', '6')
                        " @cancel="pikerShow.native_place__county1 = false" />
            </van-popup>
          </div>

        </van-cell-group>
        <!-- 举报领域 -->
        <van-cell-group class="form_filed">
          <div class="label"><span class="xinhao">*</span><span class="jianju">举报领域</span></div>

          <van-field readonly clickable name="picker" :rules="[  { required: true, message: '必填' },]" :value="reportedTradeValue" placeholder="请选择" @click="showPicker = true" class="input_box" />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="reportedTradeList" @confirm="onConfirms" @cancel="showPicker = false" />
          </van-popup>
        </van-cell-group>

        <h2 class="form-item-title">填写人举报信息</h2>

        <!-- 被举报平台 -->
        <van-cell-group class="form_filed">
          <div class="label"> <span class="xinhao">*</span><span class="jianju">企业名称</span></div>
          <van-field clickable name="picker" v-model="form.enterpriseName" placeholder="请输入企业名称" class="input_box" maxlength="50" :rules="[{ required: true, message: '必填' }]" />
        </van-cell-group>

        <van-cell-group class="form_filed">
          <div class="label"> <span class="xinhao">*</span><span class="jianju">营业执照或组织结构代码证</span></div>

          <div class="van-cell van-field van-field--error">
            <div style="padding: 1vw">
              <p style="word-wrap: break-word; word-break: break-all;color: #c0c4cc;">
                {{ '请上传营业执照或组织机构代码证清晰原件扫描件或数码照' }}
              </p>
              <div>
                <div class="material-list">
                  <div class="material-item" v-for="(item, index) in form.businessLicenseAttachment" :key="index">
                    <div class="material-item-right">
                      <div class="material-item-right-flex">
                        <div class="material-item-name">
                          <img src="../../../assets/img/24gf-fileEmpty@3x.png" alt="" style="width: 5vw; vertical-align: middle" />
                          {{ `${item.name}.${item.suffix}` }}
                        </div>
                        <div class="material-item-buttons">
                          <i class="el-icon-refresh-left" v-if="item.type === 0" style="margin-right: 0.5rem" @click="uploadChange(item.oldFile, index, 4)"></i>
                          <!-- <i class="el-icon-close"
                             v-if="item.type !== 1"
                             @click="deleteMaterial(index)"></i> -->
                          <span @click="deleteMaterial(index, 4)">删除</span>
                        </div>
                      </div>
                      <!-- <el-progress :percentage="item.process" v-if="item.type === 2"></el-progress> -->
                      <van-progress :percentage="item.process" v-if="item.type === 2" />
                      <!-- <el-progress :percentage="100" status="warning" v-if="item.type === 0"></el-progress> -->
                      <!-- <div v-if="item.type === 0"
                           class="upload-err">
                        上传失败!
                      </div> -->
                    </div>
                  </div>
                </div>
                <input type="file" ref="uploadInput4" class="upload-file" style="display: none" @change="uploadChange($event, undefined, 4)" />
                <div class="material-button" :style="form.businessLicenseAttachment.length >=10 && 'display:none'" @click.stop="uploadClick(4)">
                  请选择附件
                </div>

                <div class="upload_err">{{ uploadErrorTooltips[4] }}</div>
                <!-- <div
                  class="van-field__error-message"
                  v-if="form.attachment.length == 0"
                >
                  必填
                </div> -->

              </div>
            </div>
          </div>
        </van-cell-group>


        <!-- 企业类型 -->
        <van-cell-group class="form_filed">
          <div class="label"><span class="xinhao">*</span><span class="jianju">企业类型</span></div>

          <van-field readonly clickable name="picker" :rules="[  { required: true, message: '必填' },]" :value="enterpriseTypeValue" placeholder="请选择" @click="showPickerenterpriseTypes = true" class="input_box" />
          <van-popup v-model="showPickerenterpriseTypes" position="bottom">
            <van-picker show-toolbar :columns="enterpriseTypesList" @confirm="onConfirmenterpriseType" @cancel="showPickerenterpriseTypes = false" />
          </van-popup>
        </van-cell-group>

        <!-- 企业性质 -->
        <van-cell-group class="form_filed">
          <div class="label"><span class="xinhao">*</span><span class="jianju">企业性质</span></div>

          <van-field readonly clickable name="picker" :rules="[  { required: true, message: '必填' },]" :value="enterpriseNatureValue" placeholder="请选择" @click="showPickerenterpriseNatures = true" class="input_box" />
          <van-popup v-model="showPickerenterpriseNatures" position="bottom">
            <van-picker show-toolbar :columns="enterpriseNaturesList" @confirm="onConfirmenterpriseNature" @cancel="showPickerenterpriseNatures = false" />
          </van-popup>
        </van-cell-group>

        <!-- 行业分类 -->
        <van-cell-group class="form_filed">
          <div class="label"><span class="xinhao">*</span><span class="jianju">行业分类</span></div>

          <van-field readonly clickable name="picker" :rules="[  { required: true, message: '必填' },]" :value="enterpriseIndustryValue" placeholder="请选择" @click="showPickerenterpriseIndustries = true" class="input_box" />
          <van-popup v-model="showPickerenterpriseIndustries" position="bottom">
            <van-picker show-toolbar :columns="enterpriseIndustriesList" @confirm="onConfirmenterpriseIndustry" @cancel="showPickerenterpriseIndustries = false" />
          </van-popup>
        </van-cell-group>

        <!-- 联系人身份 -->
        <van-cell-group class="form_filed">
          <div class="label"><span class="xinhao">*</span><span class="jianju">联系人身份</span></div>

          <van-field readonly clickable name="picker" :rules="[  { required: true, message: '必填' },]" :value="contactIdentityValue" placeholder="请选择" @click="showPickerenterpriseContactIdentities = true" class="input_box" />
          <van-popup v-model="showPickerenterpriseContactIdentities" position="bottom">
            <van-picker show-toolbar :columns="contactIdentitiesList" @confirm="onConfirmenterpriseContactIdentity" @cancel="showPickerenterpriseContactIdentities = false" />
          </van-popup>
        </van-cell-group>

        <!-- 联系人材料 -->
        <van-cell-group class="form_filed">
        

          <div class="van-cell van-field van-field--error">
            <div style="padding: 1vw">
              <p style="word-wrap: break-word; word-break: break-all;color: #c0c4cc;">
                {{ '请提供联系人的身份证明和企业加盖公章的书面授权证明'}}
              </p>
              <div>
                <div class="material-list">
                  <div class="material-item" v-for="(item, index) in form.contactIdentityAttachment" :key="index">
                    <div class="material-item-right">
                      <div class="material-item-right-flex">
                        <div class="material-item-name">
                          <img src="../../../assets/img/24gf-fileEmpty@3x.png" alt="" style="width: 5vw; vertical-align: middle" />
                          {{ `${item.name}.${item.suffix}` }}
                        </div>
                        <div class="material-item-buttons">
                          <i class="el-icon-refresh-left" v-if="item.type === 0" style="margin-right: 0.5rem" @click="uploadChange(item.oldFile, index, 3)"></i>
                          <!-- <i class="el-icon-close"
                             v-if="item.type !== 1"
                             @click="deleteMaterial(index)"></i> -->
                          <span @click="deleteMaterial(index, 3)"">删除</span>
                        </div>
                      </div>
                      <!-- <el-progress :percentage="item.process" v-if="item.type === 2"></el-progress> -->
                      <van-progress :percentage="item.process" v-if="item.type === 2" />
                      <!-- <el-progress :percentage="100" status="warning" v-if="item.type === 0"></el-progress> -->
                      <!-- <div v-if="item.type === 0"
                           class="upload-err">
                        上传失败!
                      </div> -->
                    </div>
                  </div>
                </div>
                <input type="file" ref="uploadInput3" class="upload-file" style="display: none" @change="uploadChange($event, undefined, 3)"/>

                <div class="material-button" :style="form.contactIdentityAttachment.length >=10 && 'display:none'" @click.stop="uploadClick(3)">
                  请选择附件
                </div>

                <div class="upload_err">{{ uploadErrorTooltips[3] }}</div>
                <!-- <div
                  class="van-field__error-message"
                  v-if="form.attachment.length == 0"
                >
                  必填
                </div> -->

              </div>
            </div>
          </div>
        </van-cell-group>

        <h2 class="form-item-title">填写举报信息</h2>

        <!-- 被举报平台 -->
        <van-cell-group class="form_filed">
          <!-- 网站名称 -->
          <div class="label"> <span class="xinhao">*</span><span class="jianju">举报网站名称</span></div>

          <van-field clickable name="picker" v-model="form.reportedName" maxlength='30' placeholder="请输入举报网站名称" class="input_box" :rules="[{ required: true, message: '必填',  }]" />
        </van-cell-group>
        <!-- 被举报平台 -->
        <van-cell-group class="form_filed">
          <!-- 举报账号名称 -->
          <div class="label"> <span class="xinhao">*</span><span class="jianju">举报账号名称</span></div>

          <van-field clickable name="picker" v-model="form.reportedAccountName" maxlength='30' placeholder="请输入举报账号名称" class="input_box" :rules="[{ required: true, message: '必填' }]" />
        </van-cell-group>
        <!-- 详细举报网址 -->
        <van-cell-group class="form_filed">
          <div class="label"> <span class="xinhao">*</span><span class="jianju">详细举报网址</span></div>

          <van-field type="textarea" autosize name="picker" maxlength="300" v-model="form.reportedLink" placeholder="网址格式：http://www.xxx.com或https://www.xxx.com，举报多个网址请按回车键后再输入，否则无效" class="input_box" :rules="[{ required: true, message: '必填' },{ validator:this.$Common.validateInput, message: this.$Common.validateInputText }]" />
        </van-cell-group>
        <!--  -->

        <!-- 举报内容 -->
        <van-cell-group class="form_filed">
          <div class="label"> <span class="xinhao">*</span><span class="jianju">具体举报内容</span></div>
          <van-field name="picker" type="textarea" placeholder="举报内容不能为空且不能超过500个字符" maxlength="500" v-model="form.content" class="input_box textareaHeight" :rules="[{ required: true, message: '必填' }]" />
        </van-cell-group>

        <!-- --------------------------------------------------------------------------------------------- -->

        <van-cell-group class="form_filed">
          <div class="label"> <span class="xinhao">*</span><span class="jianju">举报材料</span></div>

          <div class="van-cell van-field van-field--error">
            <div style="padding: 1vw">
              <p style="word-wrap: break-word; word-break: break-all;color: #c0c4cc;">
                {{ '举报信函中请充分陈述侵权事实和处置理由，明确处置诉求，并对举报的真实性进行保证声明。举报信（函）需加盖公章' }}
                
              </p>
              <div>
                <div class="material-list">
                  <div class="material-item" v-for="(item, index) in form.attachment" :key="index">
                    <div class="material-item-right">
                      <div class="material-item-right-flex">
                        <div class="material-item-name">
                          <img src="../../../assets/img/24gf-fileEmpty@3x.png" alt="" style="width: 5vw; vertical-align: middle" />
                          {{ `${item.name}.${item.suffix}` }}
                        </div>
                        <div class="material-item-buttons">
                          <i class="el-icon-refresh-left" v-if="item.type === 0" style="margin-right: 0.5rem" @click="uploadChange(item.oldFile, index, 1)"></i>
                          <!-- <i class="el-icon-close"
                             v-if="item.type !== 1"
                             @click="deleteMaterial(index)"></i> -->
                          <span @click="deleteMaterial(index,  1)">删除</span>
                        </div>
                      </div>
                      <!-- <el-progress :percentage="item.process" v-if="item.type === 2"></el-progress> -->
                      <van-progress :percentage="item.process" v-if="item.type === 2" />
                      <!-- <el-progress :percentage="100" status="warning" v-if="item.type === 0"></el-progress> -->
                      <!-- <div v-if="item.type === 0"
                           class="upload-err">
                        上传失败!
                      </div> -->
                    </div>
                  </div>
                </div>
                <input type="file" ref="uploadInput1" class="upload-file" style="display: none" @change="uploadChange($event, undefined, 1)" />
                <div class="material-button" :style="form.attachment.length >=10 && 'display:none'" @click.stop="uploadClick(1)">
                  请上传举报信（函）
                </div>

                <div class="upload_err">{{ uploadErrorTooltips[1] }}</div>
                <!-- <div
                  class="van-field__error-message"
                  v-if="form.attachment.length == 0"
                >
                  必填
                </div> -->

              </div>
            </div>
          </div>
        </van-cell-group>

        <!-- 证据种类 -->
        <van-cell-group class="form_filed">
          <div class="label"><span class="xinhao">*</span><span class="jianju">证据种类</span></div>
          <van-field name="evidenceKinds" :rules="[{ validator: val => val && val.length > 0, message: '必填' }]">
            <template #input>
              <van-checkbox-group v-model="form.evidenceKinds" class="evidence-kinds-group">
                <van-checkbox
                  v-for="item in evidenceKinds"
                  :key="item.value"
                  :name="item.value"
                  shape="square"
                  icon-size="4vw"
                >{{ item.label }}</van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
        </van-cell-group>

        <van-cell-group class="form_filed">
          <div class="label"> <span class="xinhao">*</span><span class="jianju">证据材料</span></div>

          <div class="van-cell van-field van-field--error">
            <div style="padding: 1vw">
              <p style="word-wrap: break-word; word-break: break-all;color: #c0c4cc;">
                {{ '请提供有害信息所在页面截图及要件等材料。上传的附件单个大小不能超过200M，总数量不能超过10个。' }}
              </p>
              <div>
                <div class="material-list">
                  <div class="material-item" v-for="(item, index) in form.evidenceAttachment" :key="index">
                    <div class="material-item-right">
                      <div class="material-item-right-flex">
                        <div class="material-item-name">
                          <img src="../../../assets/img/24gf-fileEmpty@3x.png" alt="" style="width: 5vw; vertical-align: middle" />
                          {{ `${item.name}.${item.suffix}` }}
                        </div>
                        <div class="material-item-buttons">
                          <i class="el-icon-refresh-left" v-if="item.type === 0" style="margin-right: 0.5rem" @click="uploadChange(item.oldFile, index, 2)"></i>
                          <span @click="deleteMaterial(index, 2)">删除</span>
                        </div>
                      </div>
                      <van-progress :percentage="item.process" v-if="item.type === 2" />
                    </div>
                  </div>
                </div>
                <input type="file" ref="uploadInput2" class="upload-file" style="display: none" @change="uploadChange($event, undefined, 2)" />
                <div class="material-button" :style="form.evidenceAttachment.length >=10 && 'display:none'" @click.stop="uploadClick(2)">
                  请选择附件
                </div>

                <div class="upload_err">{{ uploadErrorTooltips[2] }}</div>

              </div>
            </div>
          </div>
        </van-cell-group>

        <!-- --------------------------------------------------------------------------------------------------- -->
        <van-cell-group class="form_filed">
          <div class="label">
            <span class="xinhao">*</span><span class="jianju">验证码</span>
          </div>
          <van-field name="picker" placeholder="填写验证码" v-model="form.ImgVerifyCode" class="input_box" :rules="[{ required: true, message: '必填' }]" />
          <div class="ImgCode">
            <div>
              <img :src="`data:image/png;base64,${ImgVerify}`" style="height: 10vw; width: 36vw" />
            </div>
            <div class="ImgCode_yanzheng">
              <p><span @click="yanzheng()">换一个</span></p>
            </div>
          </div>
        </van-cell-group>
        <div style="margin: 16px" class="tijiao">
          <van-button round block type="info" native-type="submit">提 交</van-button>
        </div>
        <div style="margin: 16px" class="chognzhi">
          <van-button round block native-type="button" @click="onResetValidation">重 置</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import ObsClient from 'esdk-obs-browserjs/src/obs'
import { hwTemUrlUpload } from "@/utils/upload";

export default {
  name: 'RealNameReport',
  props: ['ReportTypeId', 'IsFailRealName'],
  data () {
    return {
      params: {
        StartUpload: function () { },
        UploadProgress: function (percent, index, that) {
          that.form.attachment[index].process = percent
        },
        FileUploaded: (url, index, file) => {
          this.form.attachment[index].url = url
          this.form.attachment[index].file = file
          this.form.attachment[index].type = 1
        },
        CancelUpload: function () { }
      },
      ImgVerify: '', // 验证码
      rulesState: false,
      form: {
        realName: '', // 姓名
        gender: '', // 性别
        email: '', // 电子邮箱
        phone: '', // 手机
        province_code: { province: '', city: '',county:'' }, // 所在地
        native_place: { province1: '', city1: '',county1:'' }, // 服务地
        reportedTrade: '', // 举报领域
        damageSubKind: '684', // 危害小类
        reportedPlatform: '0', // 被举报平台
        reportedName: '', // 网站名称App名称
        reportedLink: '', // 有害信息所在页面详细网址
        targetKind: '', // app定位
        platformKind: '', // 平台类型
        accountKind: '', // 账号性质
        platformName: '',
        content: '', // 举报内容
        attachment: [], // 举报材料及要件
        ImgVerifyCode: '', // 验证码
        reportSubject:'',
        exJobKind:'',
        exUnitKind:'',
        exUnitName:'',
        enterpriseName:'',
        enterpriseType:'',
        enterpriseNature:'',
        enterpriseIndustry:'',
        contactIdentity:'',
        evidenceKinds: [],
        evidenceAttachment:[],
        contactIdentityAttachment:[],
        businessLicenseAttachment:[],
        reportedAccountName: '',//举报账号名称
        contactName:'', // 联系人姓名 
        contactPhone:'', // 联系人电话
        contactEmail:'', // 联系人邮箱
      },
      value1: 0,
      value2: 'a',
      areaList: {
        province: '请选择',
        city: '请选择',
        province1: '请选择',
        city1: '请选择',
        province_list: [],
        city_list: [],
        county_list: [],
        city_list1: [],
        county_list1: [],
        ReportingPlatform: [
          { Platform: '网站网页', id: '0' },
          { Platform: 'App', id: '1' },
          { Platform: '网络账号', id: '2' }
        ],
        targetKind: [
          { Platform: '有害信息链接', id: 1 },
          { Platform: 'App官方网址', id: 2 },
          { Platform: 'App下载地址', id: 3 }
        ],
        app: [
          {
            id: '0',
            Platform: '微信',
            nature: [
              { Platform: '个人' },
              { Platform: '公众' },
              { Platform: '群组' }
            ]
          },
          {
            id: 1,
            Platform: 'QQ',
            nature: [{ Platform: '个人' }, { Platform: '群组' }]
          },
          {
            id: 2,
            Platform: '微博',
            nature: [{ Platform: '认证' }, { Platform: '非认证' }]
          },
          {
            id: 3,
            Platform: '贴吧'
          },
          {
            id: 4,
            Platform: '博客'
          },
          {
            id: 5,
            Platform: '直播平台'
          },
          {
            id: 6,
            Platform: '论坛社区'
          },
          {
            id: 7,
            Platform: '网盘'
          },
          {
            id: 8,
            Platform: '音频'
          },
          {
            id: 9,
            Platform: '其他'
          }
        ],
        weixin: [
          { Platform: '个人' },
          { Platform: '公众' },
          { Platform: '群组' }
        ],
        reportedTrade: [], // 举报领域
        damageSubKind: [], // 危害小类
        token: {},
        currentRate: 0,
        // 账号类别 -个人 1-公众 2-群组 3-认证 4-非认证
        accountKind: [
          { id: 0, key: '个人' },
          { id: 1, key: '公众' },
          { id: 2, key: '群组' },
          { id: 3, key: '认证' },
          { id: 4, key: '非认证' }
        ],
        exJobKind: [
          { Platform: '企业人员', id: '1' },
          { Platform: '事业单位人员', id: '2' },
          { Platform: '公务员', id: '3' },
          { Platform: '学生', id: '4' },
          { Platform: '自由职业者', id: '5' },
          { Platform: '其他', id: '6' }
        ],
        exUnitKind: [
          { Platform: '机关法人', id: '1' },
          { Platform: '企业法人', id: '2' },
          { Platform: '事业单位法人', id: '3' },
          { Platform: '社会团体法人', id: '4' },
          { Platform: '其他组织', id: '5' },
        ],
      },

      uploadErrorTooltips: {
        1: '',
        2: '',
        3: '',
        4: ''
      },

      // ------------------------------------------
      province_list: [],
      city_list: [],
      county_list: [],
      reportedTradeValue: '',
      damageSubKindValue: '',
      reportedPlatformValue: '',
      targetKindValue: '',
      platformKindValue: '',
      accountKindValue: '',
      exJobKindValue:'',
      exUnitKindValue:'',
      showPicker: false,
      pikerShow: {
        province_code__province: false,
        province_code__city: false,
        province_code__county: false,
        native_place__province1: false,
        native_place__city1: false,
        native_place__county1: false
      },
      reportedTradeList: [],
      damageSubKindList: [],
      exJobKindList:['企业人员','事业单位人员','公务员','学生','自由职业者','其他'],
      exUnitKindList:['机关法人','企业法人','事业单位法人','社会团体法人','其他组织'],
      reportedPlatformList: ['网站网页', 'App', '网络账号'],
      targetKindList: ['有害信息链接', 'App官方网址', 'App下载地址'],
      platformKindList: ['微信', 'QQ', '微博', '贴吧', '博客', '直播平台', '论坛社区', '网盘', '音频', '其他'],
      allowFileTypeList: ['jpeg', 'jpg', 'png', 'mp4', 'mov', 'mp3', 'rar', 'pdf', 'doc', 'docx', 'xlsx', 'xls'],



      enterpriseTypeValue: '',
      enterpriseNatureValue: '',
      enterpriseIndustryValue: '',
      contactIdentityValue: '',
      evidenceKindValue: '',

      showPickerenterpriseNatures: false,
      showPickerenterpriseTypes: false,
      showPickerenterpriseIndustries: false,
      showPickerenterpriseContactIdentities: false,
      showPickerenterpriseEvidenceKinds: false,

      enterpriseTypes: [],//企业类型下拉框选项
      enterpriseTypesList: [],//企业类型下拉框选项
      enterpriseNatures: [],//企业性质下拉框选项
      enterpriseNaturesList: [],//企业性质下拉框选项
      enterpriseIndustries: [],//行业分类下拉框选项
      enterpriseIndustriesList: [],//行业分类下拉框选项
      contactIdentities: [],//联系人身份下拉框选项
      contactIdentitiesList: [],//联系人身份下拉框选项
      evidenceKinds: [],//证据种类下拉框选项
      evidenceKindsList: [],//证据种类下拉框选项
    }
  },
  created () {
    if(this.$route.params.id == 7){
      this.areaList.ReportingPlatform = [
          { Platform: '网站网页', id: '0' }
        ],
      this.reportedPlatformList = ['网站网页']
      this.reportedPlatformValue = '网站网页'
      this.form.reportedPlatform = '0'
      this.subId = this.$route.params.subId
      if(this.$route.params.subId && (this.$route.params.subId == 588 || this.$route.params.subId == 590)){
          this.form.reportSubject = ''
      }else{
          this.form.reportSubject = '1'
      }
    }
    // areaList市区联动查询
    this.$Api.areaList({ type: '1', parentId: '1' }).then((res) => {
      this.province_list = res.list
      this.areaList.province_list = res.list
    })
    // 行业信息
    this.$Api.dictionaryList({ type: '0' }).then((res) => {
      
      this.reportedTradeList = res.list.map(r => r.key)
      this.areaList.reportedTrade = res.list
    })
    // 危害小类
    // this.$Api
    //   .reportTypeQueryReportType({ parentId: this.ReportTypeId })
    //   .then((res) => {
    //     if(this.$route.params.subId){
    //       this.damageSubKindList = res.filter(item => item.id == this.$route.params.subId).map(r => r.typeName)
    //       // this.form.damageSubKind = Number(this.$route.params.subId)
    //       this.damageSubKindValue = this.damageSubKindList[0]
    //     }else{
    //       this.damageSubKindList = res.map(r => r.typeName)
    //     }
    //     this.areaList.damageSubKind = res
    //   })
    // 验证码
    this.yanzheng()
    // 模拟举报失败回显数据
    if (this.IsFailRealName && localStorage.getItem('reportForm')) {
      setTimeout(() => {
        const formLi = JSON.parse(localStorage.getItem('reportForm'))
        console.log('formLi::',formLi)
        this.form = formLi
        this.reportedTradeValue = formLi.reportedTrade && this.areaList.reportedTrade.find(v => v.id == formLi.reportedTrade).key
        this.damageSubKindValue = formLi.damageSubKind && formLi.damageSubKind
        this.reportedPlatformValue = formLi.reportedPlatform && this.areaList.ReportingPlatform.find(v => v.id == formLi.reportedPlatform).Platform
        this.targetKindValue = formLi.targetKind && this.areaList.targetKind.find(v => v.id == formLi.targetKind).Platform
        this.platformKindValue = formLi.platformKind && this.areaList.app.find(v => v.id == formLi.platformKind).Platform
        this.accountKindValue = formLi.accountKind && this.accountNatureList.find(v => v.value == formLi.accountKind).name

        if(formLi.enterpriseType){
          this.enterpriseTypeValue = this.enterpriseTypes.find(v => v.value == formLi.enterpriseType).label
        }
        if(formLi.enterpriseNature){
          this.enterpriseNatureValue = this.enterpriseNatures.find(v => v.value == formLi.enterpriseNature).label
        }
        if(formLi.enterpriseIndustry){
          this.enterpriseIndustryValue = this.enterpriseIndustries.find(v => v.value == formLi.enterpriseIndustry).label
        }
        if(formLi.contactIdentity){
          this.contactIdentityValue = this.contactIdentities.find(v => v.value == formLi.contactIdentity).label
        }
      }, 900)
    }
    this.getEnterpriseInfringement()
  },
  methods: {
    onConfirmCity (value, filed, clearFiled, type) {
      this.pikerShow[filed] = false
      this.form[filed.split('__')[0]][filed.split('__')[1]] = value.id
      if(value.id == 1000000){
        if(type == 3 || type == 4){
          this.form.native_place.city1 = 1000000
          this.form.native_place.county1 = 1000000
        }
        
      }else{
        if (clearFiled) {
          this.form[clearFiled.split('__')[0]][clearFiled.split('__')[1]] =
            ''
        }
        if (type === '1' || type === '3') {
          type === '1' && (this.form.province_code.county = '')
          type === '3' && (this.form.native_place.county1 = '')
          this.$Api.areaList({ type: '2', parentId: value.id }).then((res) => {
            type === '1' && (this.city_list = res.list)
            type === '3' && (this.areaList.city_list = res.list)
          })
        }else if(type === '2'){
          this.$Api.areaList({ type: '3', parentId: value.id }).then((res) => {
            this.county_list = res.list
          })
        }else if(type === '4'){
          this.$Api.areaList({ type: '3', parentId: value.id }).then((res) => {
            this.areaList.county_list = res.list
          })
        }
      }
      
      
      console.log(this.form.native_place.city1)
    },
    onConfirms (value, filed, clearFiled, type) {
      this.form.reportedTrade = this.areaList.reportedTrade[filed].id
      this.reportedTradeValue = value
      this.showPicker = false
    },
    onConfirmenterpriseType (value, filed, clearFiled, type) {
      this.form.enterpriseType = this.enterpriseTypes[filed].value
      this.enterpriseTypeValue = value
      this.showPickerenterpriseTypes = false
    },
    onConfirmenterpriseNature (value, filed, clearFiled, type) {
      this.form.enterpriseNature = this.enterpriseNatures[filed].value
      this.enterpriseNatureValue = value
      this.showPickerenterpriseNatures = false
    },
    onConfirmenterpriseIndustry (value, filed, clearFiled, type) {
      this.form.enterpriseIndustry = this.enterpriseIndustries[filed].value
      this.enterpriseIndustryValue = value
      this.showPickerenterpriseIndustries = false
    },
    onConfirmenterpriseContactIdentity (value, filed, clearFiled, type) {
      this.form.contactIdentity = this.contactIdentities[filed].value
      this.contactIdentityValue = value
      this.showPickerenterpriseContactIdentities = false
    },
    onConfirmenterpriseEvidenceKind (value, filed, clearFiled, type) {
      this.form.evidenceKind = this.evidenceKinds[filed].value
      this.evidenceKindValue = value
      this.showPickerenterpriseEvidenceKinds = false
    },
    reportedPlatformChange () {
      this.form.reportedName = ''
    },
    platformKindChange () {
      this.form.accountKind = ''
    },
    onSubmit () {
      
      // this.$toast.loading({
      //   forbidClick: true,
      //   duration: 2000
      // })
      if (this.form.attachment.length === 0) {
        this.$toast('请上传举报材料及要件')
        return
      }
      if (this.form.evidenceAttachment.length === 0) {
        this.$toast('请上传证据材料')
        return
      }
      if (this.form.contactIdentityAttachment.length === 0) {
        this.$toast('请上传联系人材料')
        return
      }
      if (this.form.businessLicenseAttachment.length === 0) {
        this.$toast('请上传营业执照或组织结构代码证')
        return
      }

      if (this.form.attachment.find(item => item.type === 0)) {
        this.uploadErrorTooltips[1] = '有失败的文件！请检查！'
      }
      if (this.form.evidenceAttachment.find(item => item.type === 0)) {
        this.uploadErrorTooltips[2] = '有失败的文件！请检查！'
      }
      if (this.form.contactIdentityAttachment.find(item => item.type === 0)) {
        this.uploadErrorTooltips[3] = '有失败的文件！请检查！'
      }
      if (this.form.businessLicenseAttachment.find(item => item.type === 0)) {
        this.uploadErrorTooltips[4] = '有失败的文件！请检查！'
      }
      if (this.form.attachment.find(item => item.type === 0) || this.form.evidenceAttachment.find(item => item.type === 0) || this.form.contactIdentityAttachment.find(item => item.type === 0) || this.form.businessLicenseAttachment.find(item => item.type === 0)) {
        this.$dialog.confirm({
          title: '提示',
          message: '上传失败！请检查文件格式'
        })
        return
      }
      const {
        realName,
        gender,
        email,
        phone,
        // eslint-disable-next-line camelcase
        province_code,
        // eslint-disable-next-line camelcase
        native_place,
        reportedTrade,
        reportedPlatform,
        reportedName,
        reportedLink,
        targetKind,
        platformKind,
        accountKind,
        platformName,
        content,
        attachment,
        ImgVerifyCode,
        damageSubKind,
        reportSubject,
        exJobKind,
        exUnitKind,
        exUnitName,

        enterpriseName,
        enterpriseType,
        enterpriseNature,
        enterpriseIndustry,
        contactIdentity,
        reportedAccountName,
        evidenceKinds,
        evidenceAttachment,
        contactIdentityAttachment,
        businessLicenseAttachment,
        contactName,
        contactPhone,
        contactEmail,
      } = this.form


      var params = {
        kind: '1',
        realName: realName,
        gender: gender,
        email,
        phone: phone,
        provinceSelf: province_code.province,
        citySelf: province_code.city,
        countySelf: province_code.county,
        provinceReported: native_place.province1,
        cityReported: native_place.city1,
        countyReported: native_place.county1,
        damageKind: this.$route.params.id,
        reportedTrade: reportedTrade,
        //
        damageSubKind: damageSubKind,
        //
        reportedPlatform: reportedPlatform,
        platformKind: platformKind,
        accountKind: accountKind,
        reportedName: reportedName,
        platformName: platformName,
        reportedLink: reportedLink,
        targetKind: targetKind,
        //
        content: content,
        attachment: JSON.stringify(attachment),
        ImgVerifyCode: ImgVerifyCode,
        reportSubject,
        exJobKind:reportSubject ==='1' ?exJobKind:'',
        exUnitKind:reportSubject ==='2' ?exUnitKind:'',
        exUnitName:reportSubject ==='2' ?exUnitName:'',

        enterpriseName: enterpriseName,
        reportedAccountName: reportedAccountName,
        enterpriseType: enterpriseType,
        enterpriseNature: enterpriseNature,
        enterpriseIndustry: enterpriseIndustry,
        contactIdentity: contactIdentity,
        evidenceKinds: evidenceKinds.join(','),
        evidenceAttachment: JSON.stringify(evidenceAttachment),
        contactIdentityAttachment: JSON.stringify(contactIdentityAttachment),
        businessLicenseAttachment: JSON.stringify(businessLicenseAttachment),
        contactName: contactName,
        contactPhone: contactPhone,
        contactEmail: contactEmail,
      }
      
      this.$toast.loading({
        message: '网络请求中...',
        forbidClick: true,
        duration: 0
      })

      this.$CookieApi
        .reportAddReport(params, localStorage.getItem('visitorHeader'), {
          callback: (res) => {
            
            this.$toast.clear()
            if (res.status == 432 || res.status == 452) {
              return this.$toast({
                  message: res.message,
                  duration: 2000
                })
            } else if (res.status != 0) {
              localStorage.setItem('reportForm', JSON.stringify(this.form))
              this.$emit('tojubaoChangestate', {
                state: false,
                name: 'RealNameReport',
                type: this.$route.params.id,
                kind: 1
              })
            }
          },
          noToast: true
        })
        .then((res) => {
          if (res) {
            // 成功
            this.$emit('tojubaoChangestate', {
              state: true,
              name: 'RealNameReport',
              data: res
            })
            localStorage.removeItem('reportForm')
            this.$toast.clear()
          } else {
            // localStorage.setItem('reportForm', JSON.stringify(this.form))
            // this.$emit('tojubaoChangestate', {
            //   state: false,
            //   name: 'RealNameReport',
            //   type: this.$route.params.id,
            //   kind: 1
            // })
          }
        })
        .catch(err => {
          console.log(err)
          if (err != 432 && err != 452) {
            this.$toast.clear()
          }
          // localStorage.setItem('reportForm', JSON.stringify(this.form))
          // this.$emit('tojubaoChangestate', {
          //   state: false,
          //   name: 'RealNameReport',
          //   type: this.$route.params.id,
          //   kind: 1
          // })
        })
    },
    onFailed () {
      this.$toast('还有必填项未完成')
    },
    addFiles () { },
    yanzheng () {
      this.$CookieApi
        .reportGetImgVerifyCode({}, localStorage.getItem('visitorHeader'))
        .then((res) => {
          if (res) {
            this.ImgVerify = res
          }
        })
        .catch()
    },
    onResetValidation () {
      const { attachment, evidenceAttachment, contactIdentityAttachment, businessLicenseAttachment } = this.form
      this.cancelPendingUploads(attachment)
      this.cancelPendingUploads(evidenceAttachment)
      this.cancelPendingUploads(contactIdentityAttachment)
      this.cancelPendingUploads(businessLicenseAttachment)
      for (const key in this.form) {
        if (Object.hasOwnProperty.call(this.form, key)) {
          this.form[key] = ''
        }
      }
      this.form.ImgVerifyCode = ''
      this.form.province_code = { province: '', city: '', county: '' }
      this.form.native_place = { province1: '', city1: '', county1: '' }
      this.city_list = []
      this.county_list = []
      this.areaList.city_list = []
      this.areaList.county_list = []
      Object.keys(this.pikerShow).forEach(key => {
        this.pikerShow[key] = false
      })
      this.form.accountKind = ''
      this.form.attachment = ''
      this.form.content = ''
      this.form.damageSubKind = '684'
      this.form.nickname = ''
      this.form.platformKind = ''
      this.form.platformName = ''
      this.form.reportedLink = ''
      this.form.reportedName = ''
      this.form.reportedPlatform = '0'
      this.form.reportedTrade = ''
      this.form.targetKind = ''
      this.form.attachment = []
      this.form.reportSubject = ''
      this.form.exJobKind = ''
      this.form.exUnitKind = ''
      this.form.exUnitName = ''
      this.reportedTradeValue = ''
      this.damageSubKindValue = ''
      this.reportedPlatformValue = ''
      this.targetKindValue = ''
      this.platformKindValue = ''
      this.accountKindValue = ''
      this.exJobKindValue = ''
      this.exUnitKindValue = ''
      this.enterpriseTypeValue = ''
      this.enterpriseNatureValue = ''
      this.enterpriseIndustryValue = ''
      this.contactIdentityValue = ''
      this.form.evidenceKinds = []
      this.form.businessLicenseAttachment = []
      this.form.evidenceAttachment = []
      this.form.contactIdentityAttachment = []
      this.form.contactIdentity = ''
      this.form.contactName = ''
      this.form.contactPhone = ''
      this.form.contactEmail = ''
      this.form.contactIdentity = ''
      this.form.contactName = ''
      this.form.contactPhone = ''
      this.form.contactEmail = ''
      this.form.reportedAccountName = ''
      this.form.enterpriseName = ''
      this.clearAllUploadErrorTooltips()
      this.clearAllUploadInputs()
      this.$refs.FormRef && this.$refs.FormRef.resetValidation()
    },
    getUploadMaxCount (type) {
      return type === 2 ? 10 : 5
    },
    clearUploadErrorTooltip (type) {
      this.uploadErrorTooltips[type] = ''
    },
    clearAllUploadErrorTooltips () {
      this.uploadErrorTooltips = { 1: '', 2: '', 3: '', 4: '' }
    },
    asValidator (val) {
      if (
        val.match(/[^\u4E00-\u9FA5A-Za-z·]/) != null ||
        val.match(/··/) != null
      ) {
        return false
      }
    },
    validateForm () { },
    provinceChange () {
      this.areaList.city_list = []
      this.$Api
        .areaList({ type: '2', parentId: this.form.province_code.province })
        .then((res) => {
          this.areaList.city_list = res.list
        })
    },
    provinceChange1 () {
      this.areaList.city_list1 = []

      this.$Api
        .areaList({ type: '2', parentId: this.form.native_place.province1 })
        .then((res) => {
          this.areaList.city_list1 = res.list
        })
    },
    getUploadInput (type) {
      return this.$refs['uploadInput' + type]
    },
    uploadClick (type = 1) {
      const uploadLimitMap = {
        1: this.form.attachment,
        2: this.form.evidenceAttachment,
        3: this.form.contactIdentityAttachment,
        4: this.form.businessLicenseAttachment
      }
      const list = uploadLimitMap[type]
      if (!list) return
      if (list.length >= this.getUploadMaxCount(type)) {
        this.uploadErrorTooltips[type] = '当前列表文件数量已超限，无法继续上传！'
        return
      }
      const input = this.getUploadInput(type)
      input && input.click()
    },
    async uploadChange (e, position, type = 1) {
      this.$toast.loading({
        duration: 1000, // 持续展示 toast
        forbidClick: true
      })
      let file
      if (e.target) {
        file = e.target.files[0]
      } else {
        file = e
      }
      if (!file) {
        this.clearInputFile(this.getUploadInput(type))
        return
      }

      const fileName = file.name
        .slice(0, file.name.lastIndexOf('.'))
        .slice(0, 20)
      const suffix = file.name.slice(file.name.lastIndexOf('.') + 1)
      const isAllowFile = this.allowFileTypeList.indexOf(file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()) > -1
      // eslint-disable-next-line no-constant-condition
      if (isAllowFile) {
        if (file.size <= 1024 * 1024 * 200) {
          const that = this
          let index
          if(position != undefined){
              index = position
              let dic = {name:fileName,process:0,file:'',type:2,suffix}
              if (type === 1) {
                  this.form.attachment[index] = dic
              } else if (type === 2) {
                  this.form.evidenceAttachment[index] = dic
              } else if (type === 3) {
                  this.form.contactIdentityAttachment[index] = dic
              } else if (type === 4) {
                  this.form.businessLicenseAttachment[index] = dic
              }
          }else{
              // this.form.attachment.push({name:fileName,process:0,file:'',type:2,suffix}) //type 上传状态类型 0->失败 1->成功 2->上传中
              // index = this.form.attachment.length - 1
              let dic = {name:fileName,process:0,file:'',type:2,suffix}//type 上传状态类型 0->失败 1->成功 2->上传中
              if (type === 1) {
                  this.form.attachment.push(dic)
                  index = this.form.attachment.length - 1
              } else if (type === 2) {
                  this.form.evidenceAttachment.push(dic)
                  index = this.form.evidenceAttachment.length - 1
              } else if (type === 3) {
                  this.form.contactIdentityAttachment.push(dic)
                  index = this.form.contactIdentityAttachment.length - 1
              } else if (type === 4) {
                  this.form.businessLicenseAttachment.push(dic)
                  index = this.form.businessLicenseAttachment.length - 1
              }
          }
          // const res = await this.$Api.getLeadToken({ key: file.name })
          const res = await this.$Api.getImageToken({ contentType:file.type,fileName:file.name })
          if(res.keyTokenParis[0].token) return hwTemUrlUpload(file, res,(percent, onCancel) => {

            if (type === 1) {
                this.form.attachment[index].process = parseInt(percent)
                this.form.attachment[index].onCancel = onCancel
            } else if (type === 2) {
                this.form.evidenceAttachment[index].process = parseInt(percent)
                this.form.evidenceAttachment[index].onCancel = onCancel
            } else if (type === 3) {
                this.form.contactIdentityAttachment[index].process = parseInt(percent)
                this.form.contactIdentityAttachment[index].onCancel = onCancel
            } else if (type === 4) {
                this.form.businessLicenseAttachment[index].process = parseInt(percent)
                this.form.businessLicenseAttachment[index].onCancel = onCancel
            }
              // this.form.attachment[index].process = parseInt(percent)
              // this.form.attachment[index].onCancel = onCancel
          }, ({src, fileName}) => {
              if (src) {
                if (type === 1) {
                    this.form.attachment[index].url = src
                    this.form.attachment[index].file = fileName
                    this.form.attachment[index].type = 1
                } else if (type === 2) {
                    this.form.evidenceAttachment[index].url = src
                    this.form.evidenceAttachment[index].file = fileName
                    this.form.evidenceAttachment[index].type = 1
                } else if (type === 3) {
                    this.form.contactIdentityAttachment[index].url = src
                    this.form.contactIdentityAttachment[index].file = fileName
                    this.form.contactIdentityAttachment[index].type = 1
                } else if (type === 4) {
                    this.form.businessLicenseAttachment[index].url = src
                    this.form.businessLicenseAttachment[index].file = fileName
                    this.form.businessLicenseAttachment[index].type = 1
                }
                  // this.form.attachment[index].url = src
                  // this.form.attachment[index].file = fileName
                  // this.form.attachment[index].type = 1
              } else {
                if (type === 1) {
                    this.form.attachment[index].type = 0
                } else if (type === 2) {
                    this.form.evidenceAttachment[index].type = 0
                } else if (type === 3) {
                    this.form.contactIdentityAttachment[index].type = 0
                } else if (type === 4) {
                    this.form.businessLicenseAttachment[index].type = 0
                } 
                  // this.form.attachment[index].type = 0
              }
          })
          

          // 上传改版  以下代码为旧版
          this.token = res

          // 上传云

          const uploader = new ObsClient({
            access_key_id: this.token.accessKey,
            secret_access_key: this.token.secretKey,
            server: this.token.endpoint,
            security_token: this.token.keyTokenParis[0].token,
            timeout: 24 * 60 * 60
          })

          // let index
          if (position != undefined) {
            index = position
            this.form.attachment[index] = {
              name: fileName,
              process: 0,
              file: '',
              type: 2,
              suffix
            }
          } else {

            let dic = {name:fileName,process:0,file:'',type:2,suffix}//type 上传状态类型 0->失败 1->成功 2->上传中
            if (type === 1) {
                this.form.attachment.push(dic)
                index = this.form.attachment.length - 1
            } else if (type === 2) {
                this.form.evidenceAttachment.push(dic)
                index = this.form.evidenceAttachment.length - 1
            } else if (type === 3) {
                this.form.contactIdentityAttachment.push(dic)
                index = this.form.contactIdentityAttachment.length - 1
            } else if (type === 4) {
                this.form.businessLicenseAttachment.push(dic)
                index = this.form.businessLicenseAttachment.length - 1
            }
            // this.form.attachment.push({
            //   name: fileName,
            //   process: 0,
            //   file: '',
            //   type: 2,
            //   suffix
            // }) // type 上传状态类型 0->失败 1->成功 2->上传中
            // index = this.form.attachment.length - 1
          }
          const options = {
            Bucket: this.token.bucket,
            Key: this.token.keyTokenParis[0].key,
            SourceFile: file,
            ProgressCallback: function (
              transferredAmount,
              totalAmount,
              totalSeconds
            ) {
              that.params.UploadProgress(
                parseInt((transferredAmount * 100) / totalAmount),
                index,
                that
              )
            }
          }

          uploader.putObject(options, function (err, res) {
            that.FileUploaded(err, uploader, index, file)
          })
          //
        } else {
          this.$dialog.alert({
            title: '提示',
            message: '上传失败！文件大小已超过200M！',
            theme: 'round-button',
            confirmButtonText: '知道了'
          })
          // this.form.attachment.push({
          //   name: fileName,
          //   file: '',
          //   type: 0,
          //   oldFile: file,
          //   suffix
          // })
          // this.dialogVisible = true
        }
      } else {
        this.$dialog.alert({
          title: '提示',
          message: '上传失败！请检查材料格式！',
          theme: 'round-button',
          confirmButtonText: '知道了'
        })
      }
      this.clearInputFile(this.getUploadInput(type))
    },
    FileUploaded (err, uploader, index, flle) {
      var key = this.token.keyTokenParis[0].key
      var sign = this.token.keyTokenParis[0].sign
      if (err) {
        console.log(err)
        return
      }
      var url = this.token.host + '/' + key
      if (sign) {
        url = url + '?' + sign
      }
      this.params.FileUploaded(url, index, flle)
      uploader = null
    },
    deleteMaterial (index, type = 1) {
      if (type == 1) {
        if (this.form.attachment[index].type === 2) {
          this.form.attachment[index].onCancel()
        }
        this.form.attachment.splice(index, 1)
        if (this.form.attachment.length < this.getUploadMaxCount(1)) {
          this.clearUploadErrorTooltip(1)
        }
      } else if (type == 2) {
        if (this.form.evidenceAttachment[index].type === 2) {
          this.form.evidenceAttachment[index].onCancel()
        }
        this.form.evidenceAttachment.splice(index, 1)
        if (this.form.evidenceAttachment.length < this.getUploadMaxCount(2)) {
          this.clearUploadErrorTooltip(2)
        }
      } else if (type == 3) {
        if (this.form.contactIdentityAttachment[index].type === 2) {
          this.form.contactIdentityAttachment[index].onCancel()
        }
        this.form.contactIdentityAttachment.splice(index, 1)
        if (this.form.contactIdentityAttachment.length < this.getUploadMaxCount(3)) {
          this.clearUploadErrorTooltip(3)
        }
      } else if (type == 4) {
        if (this.form.businessLicenseAttachment[index].type === 2) {
          this.form.businessLicenseAttachment[index].onCancel()
        }
        this.form.businessLicenseAttachment.splice(index, 1)
        if (this.form.businessLicenseAttachment.length < this.getUploadMaxCount(4)) {
          this.clearUploadErrorTooltip(4)
        }
      }
      this.clearInputFile(this.getUploadInput(type))
    },
    clearInputFile (inputEl) {
      if (!inputEl) return
      inputEl.value = ''
    },
    cancelPendingUploads (list) {
      if (!Array.isArray(list)) return
      list.forEach(item => {
        if (item && item.type === 2 && item.onCancel) {
          item.onCancel()
        }
      })
    },
    clearAllUploadInputs () {
      [1, 2, 3, 4].forEach(type => {
        this.clearInputFile(this.getUploadInput(type))
      })
    },
    getEnterpriseInfringement () {
      this.$CookieApi.enterpriseInfringement().then(data => {
        if (!data) return
        this.enterpriseTypes = data.enterpriseTypes || []
        this.enterpriseTypesList = this.enterpriseTypes.map(item => item.label)
        this.enterpriseNatures = data.enterpriseNatures || []
        this.enterpriseNaturesList = this.enterpriseNatures.map(item => item.label)
        this.enterpriseIndustries = data.enterpriseIndustries || []
        this.enterpriseIndustriesList = this.enterpriseIndustries.map(item => item.label)
        this.contactIdentities = data.contactIdentities || []
        this.contactIdentitiesList = this.contactIdentities.map(item => item.label)
        this.evidenceKinds = data.evidenceKinds || []
        this.evidenceKindsList = this.evidenceKinds.map(item => item.label)
      })
    },
  },
  computed: {
    accountKindList () {
      if (this.form.platformKind === '0') {
        return ['个人', '公众', '群组']
      } else if (this.form.platformKind === 1) {
        return ['个人', '群组']
      } else if (this.form.platformKind === 2) {
        return ['认证', '非认证']
      }
      return true
    },
    // eslint-disable-next-line vue/return-in-computed-property
    accountNatureList () {
      if (this.form.platformKind === '0') {
        return [
          {
            name: '个人',
            value: '0'
          },
          {
            name: '公众',
            value: 1
          },
          {
            name: '群组',
            value: 2
          }
        ]
      } else if (this.form.platformKind === 1) {
        return [
          {
            name: '个人',
            value: '0'
          },
          {
            name: '群组',
            value: 2
          }
        ]
      } else if (this.form.platformKind === 2) {
        return [
          {
            name: '认证',
            value: 3
          },
          {
            name: '非认证',
            value: 4
          }
        ]
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    platformNameLabel () {
      if (this.form.platformKind === 4) {
        return '博客平台'
      } else if (this.form.platformKind === 5) {
        return '直播平台名称'
      } else if (this.form.platformKind === 6) {
        return '论坛社区名称'
      } else if (this.form.platformKind === 7) {
        return '网盘名称'
      } else if (this.form.platformKind === 8) {
        return '音频平台名称'
      } else if (this.form.platformKind === 9) {
        return '平台名称'
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    platformNamePlaceholder () {
      if (this.form.platformKind === 4) {
        return '博客平台名称不能为空，且不超过40字符'
      } else if (this.form.platformKind === 5) {
        return '直播平台名称不能为空，且不超过40字符'
      } else if (this.form.platformKind === 6) {
        return '论坛平台名称不能为空，且不超过40字符'
      } else if (this.form.platformKind === 7) {
        return '网盘平台名称不能为空，且不超过40字符'
      } else if (this.form.platformKind === 8) {
        return '音频平台名称不能为空，且不超过40字符'
      } else if (this.form.platformKind === 9) {
        return '平台名称不能为空，且不超过40字符'
      }
    },
    //
    province_val () {
      const val = this.form.province_code.province ? this.province_list.find((v) => v.id / 1 === this.form.province_code.province) : ''
      const vals = val && val.name
      return vals
    },
    city_val () {
      const val = this.form.province_code.city ? this.city_list.find((v) => v.id / 1 === this.form.province_code.city) : ''
      const vals = val && val.name
      return vals
    },
    county_val () {
      const val = this.form.province_code.county ? this.county_list.find((v) => v.id / 1 === this.form.province_code.county) : ''
      const vals = val && val.name
      return vals
    },
    province1_val () {
      const val = this.form.native_place.province1 ? this.areaList.province_list.find((v) => v.id / 1 === this.form.native_place.province1) : ''
      const vals = val && val.name
      return vals
    },
    city1_val () {
      const val = this.form.native_place.city1 ? this.areaList.city_list.find((v) => v.id / 1 === this.form.native_place.city1) : ''
      const vals = val && val.name
      return vals
    },
    county1_val () {
      const val = this.form.native_place.county1 ? this.areaList.county_list.find((v) => v.id / 1 === this.form.native_place.county1) : ''
      const vals = val && val.name
      return vals
    }
  },
  watch: {
    province_val () {
      this.$Api
        .areaList({
          type: '2',
          parentId: this.form.province_code.province
        })
        .then((res) => {
          this.city_list = res.list
        })
    },
    province1_val () {
      this.$Api
        .areaList({
          type: '2',
          parentId: this.form.native_place.province1
        })
        .then((res) => {
          this.areaList.city_list = res.list
        })
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.quyu {
  display: flex;
  span {
    font-size: 3.73332vw;
    color: #646566;
    text-align: left;
    word-wrap: break-word;
  }
}
.yanzhengma {
  display: block;
  // display: flex;
  // justify-content: start;
  // align-items: center;
  div {
    margin-bottom: 5vw;
    text-align: center;
  }
  :nth-child(2) {
    // width: 20vw;
    margin-bottom: 1vw;
  }
  :nth-child(3) {
    // width: 20vw;
    margin-bottom: 1vw;
    color: #122da7;
  }
  :nth-child(4) {
    text-align: start;
  }
  .btn_code {
    display: flex;
    justify-content: center;
  }
}
// .xinhao {
//   display: flex;
//   // justify-content: center;
//   align-items: center;
//   span {
//     font-size: 4vw;
//     font-weight: 700;
//     color: #666666;
//   }
//   :first-child {
//     color: red;
//   }
// }
.biaoge {
  width: 45%;
  height: 8vw;
  border: 2px solid rgba(0, 0, 0, 0.15);
  border-radius: 1vw;
}
.biaoge1 {
  width: 100%;
  height: 8vw;
  border: 2px solid rgba(0, 0, 0, 0.15);
  border-radius: 1vw;
}
.van-field__error-message {
  font-size: 3vw;
}
.xingbieanniu {
  width: 25vw;
  height: 9vw;
  text-align: center;
  line-height: 9vw;
  background: #f6f8fa;
  margin: 0vw 2vw;
}
.xingbieanniudianji {
  font-weight: bold;
  color: #002fa7;
  background: #e9f1ff;
  border: 1px solid #002fa7;
}
.evidence-kinds-group {
  display: flex;
  flex-wrap: wrap;
  .van-checkbox {
    margin: 2vw 4vw 2vw 0;
    font-size: 3.733vw;
  }
}
.material-button {
  background-color: #002fa7;
  color: #fff;
  font-size: 4vw;
  font-weight: 700;
  width: 80%;
  height: 10vw;
  line-height: 10vw;
  text-align: center;
  margin-left: 10vw;
  margin-top: 3vw;
}
.material-item-right-flex {
  display: flex;
  justify-content: space-between;
  background-color: #f6f8fa;
  margin: 2vw 0;
}
.material-item-buttons {
  display: flex;
  align-items: center;
}

.upload_err {
  text-align: center;
  color: red;
}
.ImgCode {
  // background-color: rgb(198, 58, 58);
  text-align: center;
  margin-top: 3.2vw;
  .ImgCode_yanzheng {
    margin-top: 3.2vw;
    margin-bottom: 10.66vw;
    color: #002fa7;
  }
}

.form-item-title {
    color: #323232;
    font-size: 4.26vw;
    margin: 4vw 0;
}
.form-item-title::after {
    content: "";
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='72' height='10'%3E%3Cdefs%3E%3ClinearGradient id='a' x1='100%25' x2='0%25' y1='0%25' y2='0%25'%3E%3Cstop offset='0%25' stop-color='%23ACCBFC'/%3E%3Cstop offset='100%25' stop-color='%230A22EA'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cpath fill='none' d='M70 10V0h2v10h-2zM65 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zM5 0h2v10H5V0zM0 0h2v10H0V0z'/%3E%3Cpath fill='url(%23a)' d='M70 10V0h2v10h-2zM65 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zm-5 0h2v10h-2V0zM5 0h2v10H5V0zM0 0h2v10H0V0z'/%3E%3C/svg%3E");
    display: inline-block;
    height: 10px;
    width: 72px;
    margin-left: 5px;
}
</style>
